import { useState } from "react";
import { SubmissionSuccessPage } from "../../../components/features/onboarding/shared/submission-success-page.tsx";
import { ConsultantAgencyUsForm } from "../../../components/features/onboarding/consultant-agency-us/consultant-agency-us-form.tsx";
import styles from "../../onboard-pre-join/create-employee-page.module.css";

export default function ConsultantAgencyUsPage() {
  const [submitted, setSubmitted] = useState(false);
  if (submitted) return <SubmissionSuccessPage />;
  return (
    <div className={styles.page} data-theme="caelius-classic">
      <header className={styles.topBar}>
        <img className={styles.logo} src="/assets/images/logo.svg" alt="Caelius Consulting" width={150} />
      </header>
      <main className={styles.main}>
        <div className={styles.inner}>
          <section className={styles.heroCard} style={{ backgroundImage: "url(/assets/images/onboarding-form-card-bg.png)" }}>
            <h1 className={styles.heroTitle}>Welcome to Caelius Consulting! </h1>
            <div className={styles.heroLine} />
            <p className={`body-sm ${styles.heroIntro}`}>Please provide the required details and upload the necessary documents to complete your onboarding process.</p>
          </section>
          <ConsultantAgencyUsForm onSubmitted={() => setSubmitted(true)} />
        </div>
      </main>
    </div>
  );
}
